// Single source of truth for UI gate testids. DO NOT inline literals in components.
// Pattern: <area>/<component>[/<qualifier>]

const SAFE_ID = /^[a-z][a-z0-9-]*(\/[a-z][a-z0-9-]*(\/[a-z0-9_-]+)?)+$/;

export const TEST_IDS = {
  loginPhoneInput: 'login/phone-input',
  loginSubmit: 'login/submit',
  loginVerificationCode: 'login/verification-code',
  loginGoogleButton: 'login/google-oauth',

  chatListContainer: 'chat-list/container',
  chatListSearchInput: 'chat-list/search',

  chatMessageInput: 'chat/message-input',
  chatSendButton: 'chat/send-button',
  chatHeader: 'chat/header',
  chatMessagesContainer: 'chat/messages',

  callPanel: 'call/panel',
  callPanelStatus: 'call/panel/status',
  callPanelHangup: 'call/panel/hangup',
  callPanelAccept: 'call/panel/accept',

  settingsNav: 'settings/nav',
  settingsLogout: 'settings/nav/logout',
} as const;

export type TestIdKey = keyof typeof TEST_IDS;

// Parametric testids — always go through these helpers.
export const testId = {
  chatListItem: (peerId: number | string) => `chat-list/item/peer-${peerId}` as const,
  chatBubble: (msgId: string) => `chat/bubble/${msgId}` as const,
  reaction: (emoji: string) => `chat/reaction/${emoji.replace(/[^a-z0-9-]/gi, '_')}` as const,
};

const PARAMETRIC_PATTERNS = [
  /^chat-list\/item\/peer-[a-z0-9-]+$/,
  /^chat\/bubble\/[a-z0-9-]+$/,
  /^chat\/reaction\/[a-z0-9_-]+$/,
];

export function isKnownTestId(id: string): boolean {
  if (!SAFE_ID.test(id)) return false;
  if ((Object.values(TEST_IDS) as string[]).includes(id)) return true;
  return PARAMETRIC_PATTERNS.some((p) => p.test(id));
}
